import { useLoaderStore } from '../context/LoaderContext';
import useApiEndpoints from '../context/useApiEndpoints';
import { LoaderDetailsType } from '../types/LoaderDetailsType';

export default () => {
    const { loaderState } = useLoaderStore();
    const { apiEndpoints } = useApiEndpoints();

    const getLoaderDetailsType = (endpointUrl: string) => {
        const endpointDetails = getEndpointDetails(endpointUrl);

        if (!endpointDetails) return;

        const loaderDetails: LoaderDetailsType = {
            message: endpointDetails.loaderMessage,
            endpoint: endpointDetails.url,
            isFeatureLoader: endpointDetails.isFeatureLoader,
            type: endpointDetails.type,
        };

        return loaderDetails;
    };

    const getEndpointDetails = (endpointUrl: string) => {
        return findApiEndpoint(apiEndpoints, endpointUrl);
    };

    const findApiEndpoint = (apiEndpoints: any, endpointUrl: string) => {
        const key = Object.keys(apiEndpoints).find((key) => apiEndpoints[key].url === endpointUrl);
        if (key) return apiEndpoints[key];
    };

    const isLoadingType = (type: string) => loaderState.loaderDetails.find((l) => l.type && l.type === type);
    const isLoadingEndpoint = (endpoint: string) => loaderState.loaderDetails.find((l) => l.endpoint && l.endpoint === endpoint);

    const isLoadingTypeWithData = (type: string, property: string, value: any) => {
        return loaderState.loaderDetails.some((l) => {
            if (l.type && l.type === type && l.additionalLoaderData) {
                if (l.additionalLoaderData[property] === value) {
                    return true;
                }
            }
        });
    };

    const getVisibleLoaderMessage = (onlyFullScreenLoaders?: boolean) => {
        const details = onlyFullScreenLoaders ? loaderState.loaderDetails.find((l) => !l.isFeatureLoader) : loaderState.loaderDetails[0];
        return details?.message ?? undefined;
    };
    return { isLoadingType, isLoadingEndpoint, isLoadingTypeWithData, getVisibleLoaderMessage, getLoaderDetailsType };
};
